"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var recompose_1 = require("recompose");
var lodash_1 = require("lodash");
var utils_1 = require("../../utils");
var reduxFormWrappers_1 = require("./reduxFormWrappers");
var RadioButton_1 = require("material-ui/RadioButton");
var RadioButton_2 = require("material-ui/RadioButton");
var errorStyle = function (color) { return ({
    position: 'relative',
    bottom: -6,
    fontSize: 12,
    lineHeight: '12px',
    color: color,
    borderTop: 'solid 2px ' + color,
}); };
var RadioGroup = function (_a) {
    var items = _a.items, disabled = _a.disabled, value = _a.value, errorText = _a.errorText, rest = __rest(_a, ["items", "disabled", "value", "errorText"]);
    return (react_1.default.createElement("div", { style: { display: 'flex', flexDirection: 'column' } },
        react_1.default.createElement(RadioButton_1.RadioButtonGroup, __assign({}, rest), items.map(function (_a, i) {
            var value = _a.value, text = _a.text;
            return (react_1.default.createElement(RadioButton_2.RadioButton, { key: i, value: value, label: text, disabled: disabled }));
        })),
        react_1.default.createElement("div", { style: errorText ? errorStyle('red') : { height: '14px' } }, errorText)));
};
var compareFn = function (val1, val2) {
    return lodash_1.isObject(val1) && lodash_1.isObject(val2) ? lodash_1.get(val1, 'id') === lodash_1.get(val2, 'id') : val1 === val2;
};
var ComposedRadioGroup = recompose_1.compose(recompose_1.pure, recompose_1.defaultProps({
    labelFunction: lodash_1.identity,
    valueFunction: lodash_1.identity,
    items: [],
    onChange: lodash_1.noop,
    compareFn: compareFn,
    dropDownMenuProps: {
        maxHeight: 250,
        menuItemStyle: { whiteSpace: 'normal' },
    },
}), recompose_1.mapProps(function (_a) {
    var labelFunction = _a.labelFunction, valueFunction = _a.valueFunction, items = _a.items, compareFn = _a.compareFn, rest = __rest(_a, ["labelFunction", "valueFunction", "items", "compareFn"]);
    return (__assign({ labelFunction: utils_1.safe(labelFunction), valueFunction: utils_1.safe(valueFunction, ''), items: items.map(function (item) { return ({
            text: labelFunction(item),
            value: valueFunction(item),
        }); }) }, rest));
}), recompose_1.mapProps(function (_a) {
    var value = _a.value, items = _a.items, valueFunction = _a.valueFunction, rest = __rest(_a, ["value", "items", "valueFunction"]);
    return (__assign({ value: value ? items.map(function (item) { return item.value; }).find(function (v) { return compareFn(v, value); }) : value, items: items }, rest));
}), recompose_1.renameProp('value', 'valueSelected'), recompose_1.withHandlers({
    onChange: function (_a) {
        var onChange = _a.onChange;
        return function (event, value) { return onChange(value); };
    },
}))(RadioGroup);
exports.default = ComposedRadioGroup;
exports.FormRadioButtonGroup = reduxFormWrappers_1.formWrapper(ComposedRadioGroup);
//# sourceMappingURL=RadioGroup.js.map


//////////////////
// WEBPACK FOOTER
// .-core/es/components/controls/RadioGroup.js
// module id = 2564
// module chunks = 0